import { useAtom, useAtomValue } from "jotai";
import * as React from "react";
import { useLocation } from "react-router-dom";
import { CHAT_EXCLUDED_PATHS } from "../../domain/chat/exclusions";
import { chatStatusAtom, chatSuppressionsAtom } from "../../domain/chat/state";
import { isChatVisible, launcherView } from "../../domain/chat/visibility";
import { ChatIcon, FAB } from "../../themeV2";
import css from "./ChatLauncher.module.css";
import { findChatBot, loadChatWidget } from "./loadChatWidget";

const useHostVisibility = ({ ready, visible }) =>
  React.useEffect(() => {
    if (!ready) return;
    findChatBot().style.display = visible ? "" : "none";
  }, [ready, visible]);

export default function ChatLauncher() {
  const { pathname } = useLocation();
  const suppressions = useAtomValue(chatSuppressionsAtom);
  const [status, setStatus] = useAtom(chatStatusAtom);

  const visible = isChatVisible({
    pathname,
    suppressions,
    excludedPaths: CHAT_EXCLUDED_PATHS,
  });
  const view = launcherView({ status, visible });

  useHostVisibility({ ready: status === "ready", visible });

  const openChat = React.useCallback(() => {
    setStatus("loading");
    loadChatWidget().then(
      () => setStatus("ready"),
      () => setStatus("failed"),
    );
  }, [setStatus]);

  return view === "hidden" ? null : (
    <FAB
      className={css.launcher}
      size="md"
      color="primary-container"
      label="Open chat"
      icon={<ChatIcon />}
      loading={view === "busy"}
      onClick={openChat}
    />
  );
}
